import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
// import Backend from 'i18next-xhr-backend'
import en from './languages/en'
import pl from './languages/pl'
import { LANGUAGE_NAMESPACE } from './languages/i18nConfig'

i18n
  // .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    pluralSeparator: '_',
    fallbackLng: 'pl',
    ns: [LANGUAGE_NAMESPACE.DEFAULT],
    debug: true,
    defaultNS: LANGUAGE_NAMESPACE.DEFAULT,
    resources: {
      en: {
        [LANGUAGE_NAMESPACE.DEFAULT]: en,
      },
      pl: {
        [LANGUAGE_NAMESPACE.DEFAULT]: pl,
      },
    },
    initImmediate: false, // Initialize synchronously since resources are bundled
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  })

export default i18n
